var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 7.19995H6.5999V10.8H5.3999V7.19995Z",
    fill: "#084864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00005 3C2.33729 3 1.80005 3.53724 1.80005 4.2V6.6H3.00005H4.20005V4.2C4.20005 3.53724 3.66281 3 3.00005 3Z",
    fill: "#084864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40001 2.99995H4.33789C4.62409 3.31879 4.80001 3.73867 4.80001 4.19995V6.59995H10.2V4.19995C10.2 3.53719 9.66277 2.99995 9.00001 2.99995H6.60001V4.19995C6.60001 4.53127 6.33133 4.79995 6.00001 4.79995H5.40001V4.19995H6.00001V3.59995V2.99995V2.39995H7.20001V1.19995H5.40001V1.79995V2.39995V2.99995Z",
    fill: "#084864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.cdab91f1e1d09a80e16783e9a3edbc7b.svg";
export { ForwardRef as ReactComponent };